import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex align-items-end" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "fs-20 mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block mb-1" }, "Total Item", -1)),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.total), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink-0 me-3 me-auto" }, [
          _createElementVNode("i", {
            class: "ri-truck-line fs-24 text-white bg-primary d-inline-block text-center rounded-circle text-white",
            style: {"width":"60px","height":"60px","line-height":"60px"}
          })
        ], -1))
      ])
    ])
  ]))
}